import { Controller } from "@hotwired/stimulus";
import MicroModal from "micromodal";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["resourceField", "checkListField", "inspectionRange", "subGroup", "lat", "lon"];
  static values = {
    customerCode: String,
  };

  declare readonly resourceFieldTarget: HTMLSelectElement;
  declare readonly checkListFieldTarget: HTMLSelectElement;
  declare readonly inspectionRangeTarget: HTMLSelectElement;
  declare readonly subGroupTarget: HTMLSelectElement;
  declare readonly latTarget: HTMLInputElement;
  declare readonly lonTarget: HTMLInputElement;
  declare readonly hasResourceFieldTarget: boolean;
  declare readonly hasCheckListFieldTarget: boolean;
  declare readonly hasLatTarget: boolean;
  declare readonly hasLonTarget: boolean;
  declare readonly customerCodeValue: string;

  connect() {
    MicroModal.init({
      disableScroll: true,
      awaitCloseAnimation: true,
    });
  }

  async fetchResources() {
    const inspection_range = this.inspectionRangeTarget.value;
    const sub_group = this.subGroupTarget.value;
    const params = new URLSearchParams({
      inspection_range,
      "q[heavy_machine_sub_group_id_in]": sub_group,
    });

    if (this.hasLatTarget && this.latTarget.value) {
      params.append("inspection_lat", this.latTarget.value);
    }
    if (this.hasLonTarget && this.lonTarget.value) {
      params.append("inspection_lon", this.lonTarget.value);
    }

    const url = `/${this.customerCodeValue}/inspections/resources?${params.toString()}`;

    try {
      const res = await fetch(url, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin",
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      Turbo.renderStreamMessage(html);
    } catch (err) {
      console.error("[Turbo fetch error]", err);
    }
  }

  open(event: Event) {
    event.preventDefault();
    MicroModal.show("advanced-search-modal");
  }

  close() {
    MicroModal.close("advanced-search-modal");
  }

  selectResource(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const resourceId = target.dataset.resourceId;

    // フォームフィールドにIDをセット
    if (this.hasResourceFieldTarget && resourceId) {
      this.resourceFieldTarget.value = resourceId;
      // changeイベントを発火してStimulusコントローラーをトリガー
      this.resourceFieldTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }

    this.close();
  }
}
